/* eslint-disable @typescript-eslint/consistent-type-imports */
// import { graphql } from 'react-relay';
import isEqual from 'lodash/isEqual';
import type { GraphQLSingularResponse } from 'relay-runtime';

// import { writeQueryInterop } from '@confluence/apollo-relay-interop/entry-points/writeQuery';
import { getClientStream } from '@confluence/ssr-data-streaming/entry-points/client.ts';

import { getCacheableRelaySSRResponse } from './relaySSRHydrationContext.ts';
// oxlint-disable-next-line import/no-cycle
import { Event } from './streaming.ts';

export class RelayQueryResultCache {
	private queryResults: Map<string, { result: GraphQLSingularResponse; variables: object }[]>;

	/**
	 * The listener for the client stream to cache the query results is set in this constructor.
	 */
	constructor(namespace: string) {
		this.queryResults = new Map();

		const data = getClientStream(namespace);

		data.addListener((event: Event): void => {
			if (event.type !== 'result') {
				return;
			}

			const cacheableResponse = getCacheableRelaySSRResponse(event.result);
			if (cacheableResponse) {
				this.addResult(event.operation, cacheableResponse, event.variables);
			}
		});
	}

	getMatchingResult(query: string, variables: object): GraphQLSingularResponse | null {
		const results = this.queryResults.get(query);

		if (!results) {
			return null;
		}

		const matchingQueryResult = results.findIndex((result) => isEqual(result.variables, variables));

		if (matchingQueryResult === -1) {
			return null;
		}

		const matchingData = results[matchingQueryResult].result;
		results.splice(matchingQueryResult, 1);
		this.queryResults.set(query, results);
		return matchingData;
	}

	addResult(query: string, result: GraphQLSingularResponse, variables: object): void {
		const results = this.queryResults.get(query) || [];
		results.push({ result, variables });
		this.queryResults.set(query, results);
	}
}
